// extracted by mini-css-extract-plugin
export default {"container":"FilePreview_container__KZmiv"};